//# sourceMappingURL=my-options.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydatepicker/dist/interfaces/my-options.interface.js
// module id = 552
// module chunks = 0